/* eslint-disable max-len */
/* eslint-disable no-console */
/**
 * API_Name: Move_To_Trash
 * Type: Custome Hooks
 */
import { useContext } from 'react';
import { moveTrash } from '../../actions/media_actions';
import { useParams } from 'react-router-dom';
import { MediaContext } from '..';
import useGetMyFolders from './useGetMyFolder';
import { toast } from 'react-toastify';
import useGetEmployeList from './useGetEmployeList';
import useCustomTemplate from './useCustomTemplare';
import { LanguageContext } from '../../../libs/Context';

const useMoveToTrash = () =>
{
	const parentId = useParams()?.id || '';
	const { mediaState, setMediaState } = useContext(MediaContext);
	const { language } = useContext(LanguageContext);
	const tabValue:any = useParams()?.tab || '';

	const getFoldersData = useGetMyFolders({ });
	const getEmployeList = useGetEmployeList();
	const getTemplatesData = useCustomTemplate({ debounceSearchTerm: '' });

	const getMoveToTrash = async ({ idArray, userId, setLoading }) =>
	{
		setLoading(true);
		const body:any = tabValue === 'employee' && userId ? { isroot: 'true', userId } : { id: idArray, userId: parentId };

		try
		{
			const response = await moveTrash(body);

			if (response?.status)
			{
				mediaState?.selectedData?.length > 0 && setMediaState({ type: 'updateReducer', payload: { selectedData: [], allSelected: false } });

				mediaState?.page > 0
					? setMediaState({ type: 'updateReducer', payload: { page: 0 } })
					: tabValue === 'template'
						? getTemplatesData()
						: !([ 'employee', 'template' ]?.includes(tabValue) && userId)
							? getFoldersData()
							: getEmployeList();

				toast.success(language?.fileMoveTrash, {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});
				setLoading(false);
			}
			else
			{
				setLoading(false);
			}
		}
		catch (err)
		{
			console.log('error: ', err);
			setLoading(false);
		}
	};

	return getMoveToTrash;
};

export default useMoveToTrash;